module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('el-container', {
    staticStyle: {
      "height": "100%"
    }
  }, [(false) ? _c('el-header', [_c('router-view', {
    attrs: {
      "name": "header"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-main', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-container', {
    staticStyle: {
      "height": "100%"
    }
  }, [(_vm.headerIsShow) ? _c('el-aside', [_c('router-view', {
    attrs: {
      "name": "aside"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-aside', {
    class: _vm.$route.name
  }, [_c('router-view', {
    attrs: {
      "name": "left"
    }
  })], 1), _vm._v(" "), _c('el-main', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('router-view', {
    key: _vm.$route.fullpath
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-91d07322", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-91d07322","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 562
// module chunks = 129